/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_PermanentInputs */

const en_common_permanent = /** @type {(inputs: Common_PermanentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permanent`)
};

const es_common_permanent = /** @type {(inputs: Common_PermanentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permanente`)
};

/**
* | output |
* | --- |
* | "Permanent" |
*
* @param {Common_PermanentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_permanent = /** @type {((inputs?: Common_PermanentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_PermanentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_permanent(inputs)
	return en_common_permanent(inputs)
});